import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaEllipsisV, FaBoxOpen, FaShoppingBag, FaShoppingCart, FaCreditCard, FaHistory, FaCog, FaHome, FaQrcode } from 'react-icons/fa';
import { FiLogOut } from 'react-icons/fi';
import AppHeader from "./AppHeader"; // Assuming AppHeader is already styled
import './BottomNavbar.css'; // Import any additional custom styles
import { endpoint } from "./endpoint";
import { useSubscription } from './SubscriptionContext'; // Import SubscriptionContext
import { useUser } from "./UserContext"; // Import UserContext

const BottomNavbar = () => {
    const [showMenu, setShowMenu] = useState(false);
    const [bagsCount, setBagsCount] = useState(0);
    const [ordersCount, setOrdersCount] = useState(0);
    const navigate = useNavigate();
    const menuRef = useRef(null);
    const menuButton = useRef(null);
    const { subscription, isSubscribed } = useSubscription(); // Use SubscriptionContext
    const { user } = useUser(); // Use UserContext

    const toggleMenu = () => {
        setShowMenu(prevState => !prevState);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && event.target !== menuButton.current) {
                setShowMenu(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (user) {
            // Fetch bags count
            fetch(`${endpoint}/gymapp/getbags.php?token=${user.token}`)
                .then(response => response.json())
                .then(data => {
                    if (data.bags) {
                        setBagsCount(data.bags.filter(bag => bag.inOrder).length);
                    } else {
                        console.error('Error fetching bags:', data.message);
                    }
                })
                .catch(error => console.error('Error fetching bags:', error));

            // Fetch orders count
            fetch(`${endpoint}/gymapp/getpendingorders.php?token=${user.token}`)
                .then(response => response.json())
                .then(data => {
                    if (Array.isArray(data)) {
                        setOrdersCount(data.length);
                    } else {
                        console.error('Error fetching orders:', data.message);
                    }
                })
                .catch(error => console.error('Error fetching orders:', error));
        }
    }, [user]);

    const logout = async () => {
        if (!user?.token) {
            navigate('/login');
            return;
        }

        try {
            const response = await fetch(`${endpoint}/gymapp/logout.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token: user.token })
            });

            const data = await response.json();

            if (data.status === 'success') {
                localStorage.removeItem('authToken');
                navigate('/login');
            } else {
                console.error('Logout failed:', data.message);
            }
        } catch (error) {
            console.error('Error logging out:', error);
        }
    };

    return (
        <>
            <AppHeader navigate={navigate} toggleMenu={toggleMenu} />

            {/* Bottom Navbar */}
            <div className="d-flex justify-content-around align-items-center bg-light fixed-bottom py-2 border-top">
                <div className="text-center position-relative" onClick={() => navigate('/dashboard')}>
                    <FaHome size={24} />
                    <span className="d-block">Home</span>
                </div>
                <div className="text-center position-relative">
                    
					  {subscription ? (
					  <>
                   <FaShoppingCart onClick={() => navigate("/create-collection")} size={24} />
					<span onClick={() => navigate("/create-collection")} className="d-block">Place Order</span>
                </>
                ) : (
				<>
				<FaShoppingCart onClick={() => navigate("/order")} size={24} />
				<span onClick={() => navigate("/order")} className="d-block">Place Order</span>
                    </>
                )}
                    
                </div>
                <div className="text-center position-relative" onClick={() => navigate('/bags')}>
                    <FaShoppingBag size={24} />
                    {bagsCount > 0 && <span className="badge">{bagsCount}</span>}
                    <span className="d-block">Bags</span>
                </div>
                <div className="text-center position-relative" onClick={() => navigate('/collections')}>
                    <FaBoxOpen size={24} />
                    {ordersCount > 0 && <span className="badge">{ordersCount}</span>}
                    <span className="d-block">Orders</span>
                </div>
                <div className="text-center" onClick={() => navigate('/scan')}>
                    <FaQrcode size={24} />
                    <span className="d-block">Scan</span>
                </div>
                <div className="text-center d-none" ref={menuButton} onClick={toggleMenu}>
                    <FaEllipsisV size={24} />
                </div>
            </div>

            {/* Fixed Pay Buttons */}
         

            {/* Logout Button (optional) */}
            {showMenu && (
                <div ref={menuRef} className="menu">
                    <div className="menu-item" onClick={logout}>
                        <FiLogOut size={20} />
                        <span>Logout</span>
                    </div>
                </div>
            )}
        </>
    );
};

export default BottomNavbar;
